<template>
    <div>

        <v-row >
            <v-col>
                <autocompleteOneForm
                    label="Periodicidad"
                    :valueInput="values.periodicity"
                    :rule="rules.required"
                    :items="serverItems.periodicities"
                    :errorMessages="serverErrors.periodicity"
                    @valueChange="(v) => {values.periodicity = v; this.calculatePeriods(v); delete serverErrors.periodicity}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row >
            <v-col>
                <autocompleteOneForm
                    label="Año"
                    :valueInput="values.year"
                    :rule="rules.required"
                    :items="serverItems.years"
                    :errorMessages="serverErrors.year"
                    @valueChange="(v) => {values.year = v; this.calculatePeriods(values.periodicity); delete serverErrors.year}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row v-if="!edit">
            <v-col>
                <autocompleteOneForm
                    label="Periodo"
                    :valueInput="values.period"
                    :rule="rules.required"
                    :items="serverItems.periods"
                    :errorMessages="serverErrors.period"
                    @valueChange="(v) => {values.period = v; delete serverErrors.period}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row >
            <v-col>
                <autocompleteOneForm
                    label="Evaluador"
                    :loading="loadingEmployees"
                    :valueInput="values.evaluator_id"
                    :rule="rules.required"
                    :items="serverItems.employees"
                    :errorMessages="serverErrors.evaluator_id"
                    @valueChange="(v) => {values.evaluator_id = v; delete serverErrors.evaluator_id;}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row >
            <v-col>
                <autocompleteOneForm
                    label="Evaluados"
                    :loading="loadingEmployees"
                    :valueInput="evaluated"
                    :rule="[]"
                    :items="serverItems.employees"
                
                    @valueChange="(v) => {evaluated = v;}"
                ></autocompleteOneForm>
                   
            </v-col>
            <iconButton class="mt-3 mr-3" :props="addEvaluatedBtnData"></iconButton>
        </v-row>

        <v-row>
            <v-col> 
                <div class="evaluations-evaluated-list" v-for="(item, index) in values.evaluated" :key="index">
                    <span class="evaluations-evaluated-list-text">{{item.text}}</span>
                    <v-btn
                    color="black"
                    plain
                    icon
                    @click="deleteEvaluated(index)"
                    ><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                </div>
            </v-col>
        </v-row>
        
    
    </div>
</template>

<script>

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
   
    data(){
        return {
            showPass: false,
            loadingCompanies: false,
            loadingEmployees: false,
            loadingRoles: false,
            evaluated:'',

            rules: {
                required: [
					v => {
                        if(v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if(v.toString().trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
				],
                
				
            },
            serverItems: {
                periodicities:[
                    {text: "Mes", value: 'MENSUAL'},
                    {text: "Bimestre", value: 'BIMESTRAL'},
                    {text: "Trimestre", value: 'TRIMESTRAL'},
                    {text: "Semestre", value: 'SEMESTRAL'},
                    {text: "ANUAL", value: 'ANUAL'},
                ],
                periods:[],
                employees:[],
                years:[],
            },
            addEvaluatedBtnData:{
                hasTooltip:false,
                tooltip: 'Agregar evaluado',
                color:'primary',
                height:'39',
                text: "",
                icon: "mdi-plus",
				to: "",
				block: true,
                click: ()=>{this.addEvaluated()}
            }

          
        }
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        }
    },
    mounted(){
        this.getYears();
        this.getEmployees();
    },
    methods: {

        addEvaluated()
        {
            console.log(this.evaluated)
           
            const duplicated = this.values.evaluated.find((x) => x.value == this.evaluated);
            if(duplicated != undefined)
                return;
            const found = this.serverItems.employees.find((x) => x.value == this.evaluated);
            if(found == undefined)
                return;
            
            this.values.evaluated.push(
                {text: found.text, value:this.evaluated}
            );

        },

        getEmployees()
        {
            
            this.loadingEmployees = true;
            this.$api.employees.selectBasic()
                .then((resp) => {
                    // this.serverItems.employees = [];
                    this.serverItems.employeesData = resp.data;
                    this.serverItems.employees = resp.data.map((emp) =>{
                        return {value:emp.id, text:emp.name}
                    });
                   
                })
                .catch((error) => {
                    console.log(error, "assing form");
                })
                .finally(() =>{
                    this.loadingEmployees = false;
                })
            ;
        },

        getYears(){
            this.serverItems.years = [];
            const currentYear = new Date().getFullYear();

            for (let i = 2025; i < (currentYear + 2); i++) {
                this.serverItems.years.push({text:i, value:i});
            }

        },

        calculatePeriods(v)
        {
            this.values.period = "";
            if(v == null || v == undefined || v == "")
                return;

            if(this.values.year == null || this.values.year == undefined || this.values.year == "")
                return;

            // const dateYear = new Date().getFullYear();
            const dateYear = this.values.year;
            this.serverItems.periods = [];

            if(v == "MENSUAL"){
                this.serverItems.periods.push(
                    {text: `Enero - ${dateYear}`, value: `Enero - ${dateYear}`},
                    {text: `Febrero - ${dateYear}`, value: `Febrero - ${dateYear}`},
                    {text: `Marzo - ${dateYear}`, value: `Marzo - ${dateYear}`},
                    {text: `Abril - ${dateYear}`, value: `Abril - ${dateYear}`},
                    {text: `Mayo - ${dateYear}`, value: `Mayo - ${dateYear}`},
                    {text: `Junio - ${dateYear}`, value: `Junio - ${dateYear}`},
                    {text: `Julio - ${dateYear}`, value: `Julio - ${dateYear}`},
                    {text: `Agosto - ${dateYear}`, value: `Agosto - ${dateYear}`},
                    {text: `Septiembre - ${dateYear}`, value: `Septiembre - ${dateYear}`},
                    {text: `Octubre - ${dateYear}`, value: `Octubre - ${dateYear}`},
                    {text: `Noviembre - ${dateYear}`, value: `Noviembre - ${dateYear}`},
                    {text: `Diciembre - ${dateYear}`, value: `Diciembre - ${dateYear}`},
                );
                return;
            }
            if(v == "BIMESTRAL"){
                this.serverItems.periods.push(
                    {text: `Enero - Febrero ${dateYear}`, value: `Enero - Febrero ${dateYear}`},
                    {text: `Marzo - Abril ${dateYear}`, value: `Marzo - Abril ${dateYear}`},
                    {text: `Mayo - Junio ${dateYear}`, value: `Mayo - Junio ${dateYear}`},
                    {text: `Julio - Agosto ${dateYear}`, value: `Julio - Agosto ${dateYear}`},
                    {text: `Septiembre - Octubre ${dateYear}`, value: `Septiembre - Octubre ${dateYear}`},
                    {text: `Noviembre - Diciembre ${dateYear}`, value: `Noviembre - Diciembre ${dateYear}`},
                );
                return;
            }
            if(v == "TRIMESTRAL"){
                this.serverItems.periods.push(
                    {text: `Enero - Marzo ${dateYear}`, value: `Enero - Marzo ${dateYear}`},
                    {text: `Abril - Junio ${dateYear}`, value: `Abril - Junio ${dateYear}`},
                    {text: `Julio - Septiembre ${dateYear}`, value: `Julio - Septiembre ${dateYear}`},
                    {text: `Octubre - Diciembre ${dateYear}`, value: `Octubre - Diciembre ${dateYear}`},
                );
                return;
            }
            if(v == "SEMESTRAL"){
                this.serverItems.periods.push(
                    {text: `Enero - Junio ${dateYear}`, value: `Enero - Junio ${dateYear}`},
                    {text: `Julio - Diciembre ${dateYear}`, value: `Julio - Diciembre ${dateYear}`},
                );
                return;
            }
            if(v == "ANUAL"){
                this.serverItems.periods.push(
                    {text: `Enero - Diciembre ${dateYear}`, value: `Enero - Diciembre ${dateYear}`},
                );
                return;
            }
        },

        deleteEvaluated(value)
        {
            console.log(value);
            this.values.evaluated.splice(value, 1);
        },
      
    }
}
</script>

<style lang="scss">
    .evaluations {
        &-evaluated-containter{
            display: flex;
        }



        &-evaluated-list{
            display: flex;
            justify-content: space-between;
            border-bottom: rgba(13, 13, 13, 0.145) solid 1px;


            &-text{
                align-content: center;
            }
        }
    }
</style>